import moment from 'moment'
import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { Navigate } from 'react-router-dom'
import { Page } from '../../../components'
import { MapContainer } from '../../../containers'
import { appsStyleSelected } from '../../../helpers/app'
import { images } from '../../../images'
import { AuthenticatedRoutable, ICoordinate, IReservation } from '../../../models'
import { IExpeditionStatus } from '../../../models/expedition-status'
import { urls } from '../../../routing'
import { LiteralsService, ReservationService } from '../../../services'
import { setExpeditionStatusAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from './styles'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  pickedReservation: IReservation | null
}

interface IState {
  reservation: IReservation | null
  busLocation: ICoordinate | null
  delay: number
}

class DetailsFullscreenMap extends AuthenticatedRoutable<IProps, IState> {
  private busInterval: any

  constructor(props: IProps) {
    super(props)

    const state = props.location.state || {}
    this.state = {
      reservation: state.reservation ?? props.pickedReservation ?? null,
      busLocation: state.busLocation ?? null,
      delay: state.delay ?? 0
    }
  }

  public componentDidMount(): void {
    super.componentDidMount()

    if (!this.state.reservation) return

    this.busIntervalFunction()
    this.busInterval = setInterval(this.busIntervalFunction, 2000)
  }

  public componentWillUnmount(): void {
    clearInterval(this.busInterval)
  }

  public render(): ReactNode {
    const { reservation, busLocation } = this.state

    // Reached without a reservation (deep link, or a refresh that lost the
    // history state): there is nothing to draw, so leave for the list.
    if (!reservation) return <Navigate to={ urls.reservations } replace />

    return (
      <Page className={ `authenticated ${appsStyleSelected?.style}` }>
        <StyledArticle>
          <header>
            <h3>{ LiteralsService.get('reservationDetails', true) }</h3>
            <img src={ images['cross'] } className="close-fullscreen-map" onClick={ this.handleClose } alt="" />
          </header>
          <div className="map">
            <MapContainer
              path={ reservation.path }
              inStop={ reservation.beginningStop }
              outStop={ reservation.seats[0].exitStop }
              busLocation={ busLocation }
              serviceInfos={ [] }
              correction={ 0.00005 }
              showFullscreenControl={ false }
              controlsEnabled
            />
          </div>
        </StyledArticle>
      </Page>
    )
  }

  private handleClose = (): void => {
    this.props.history.goBack()
  }

  private busIntervalFunction = async (): Promise<void> => {
    const { reservation } = this.state
    const { dispatch } = this.props

    if (!reservation) return

    let expeditionStatus = IExpeditionStatus.Empty
    try {
      expeditionStatus = await ReservationService.getReservationStatus(reservation.id)
    } catch (error) {
      expeditionStatus = IExpeditionStatus.Closed
    }
    if (reservation.cancelled) expeditionStatus = IExpeditionStatus.Cancelled
    dispatch(setExpeditionStatusAction(expeditionStatus))

    const oldDelay = this.state.delay
    let busLocation = null
    let delay = this.state.delay
    const now = moment()
    const endStopWithDelay = moment(reservation.seats[0].exitStop.dateTime).add(delay, 'minutes')

    if (
      (expeditionStatus === IExpeditionStatus.Ready || expeditionStatus === IExpeditionStatus.Ongoing) &&
      now.isSameOrBefore(endStopWithDelay)
    ) {
      try {
        const response = await ReservationService.getBusPosition(reservation.id)
        busLocation = {
          latitude: response.latitude,
          longitude: response.longitude,
          color: response.color
        }
        delay = response.delay
      } catch (error) {
        busLocation = null
      }
    }

    this.setState({
      busLocation,
      delay: delay !== oldDelay ? delay : oldDelay
    })
  }
}

const mapStateToProps = ({ reservations }: IStoreState) => ({
  pickedReservation: reservations.pickedReservation
})

export default withRouter(connectRedux(mapStateToProps, DetailsFullscreenMap as any))
